import { createSelector } from '@reduxjs/toolkit'

import { getViewedSessionId } from './ui'

const getState = state => state.screenshots
const getSession = id => state => getState(state).map[id || getViewedSessionId(state)]

export const getFetchingInProgress = id => state => getSession(id)(state)?.fetchingInProgress

export const selectScreenshots = id => createSelector(
  getSession(id),
  session => session?.content ?? {}
)

export const selectHasMorePages = id => state => getSession(id)(state)?.hasMoreScreenshots ?? true
export const selectLastScreenshotsPageIndex = id => state => getSession(id)(state)?.lastScreenshotsPageIndex ?? -1
export const getSelectedScreenshotId = id => state => getSession(id)(state)?.selectedScreenshotId

export const getScreenshotsCount = id => createSelector(
  getSession(id),
  session => Object.values(session?.content ?? {}).length
)

export const getAreScreenshotUrlsExpired = id => createSelector(
  getSession(id),
  session => {
    const now = new Date().getTime()
    const expiryTime = session?.nextExpiryTimestamp ?? 0

    return now > expiryTime
  }
)
